// extracted by mini-css-extract-plugin
export default {"contactWrapper":"Contact_contactWrapper__kBtf7","contactItem":"Contact_contactItem__K08bu","contact":"Contact_contact__N4Ggx"};